// Transforms /shows/ from plain hand-edited HTML (an <h3> per tour,
// one <p> per date reading "Date -- Venue, City, Region", sometimes
// with a <br><em>note</em> underneath) into ledger rows/sections --
// same idea as sidenotes.js rewriting [[N]] markers, so the source
// content stays trivial to keep hand-editing (add a show, just type
// another <p> under the right tour's <h3>).

// Split on the first en/em dash only -- a plain hyphen inside a date
// range ("November 5-6 / 21") must not be mistaken for the separator.
// Koenig often turns the space typed after a dash into a non-breaking
// one, which innerHTML serializes as "&nbsp;" -- \s can't see that, so
// it would survive as an indent at the start of the venue.
const SPACE = "(?:\\s|&nbsp;)*";
const SEPARATOR_RE = new RegExp(`^${SPACE}([\\s\\S]*?)${SPACE}[–—]${SPACE}([\\s\\S]*?)${SPACE}$`);

function splitShowLine(html) {
    const match = html.match(SEPARATOR_RE);
    if (!match) { return null; }
    return { date: match[1], venue: match[2] };
}

function buildShowRow(p) {
    const parsed = splitShowLine(p.innerHTML);
    if (!parsed) { return null; }

    const row = document.createElement("div");
    row.className = "show-row";

    const venue = document.createElement("span");
    venue.className = "show-row-venue";
    venue.innerHTML = parsed.venue;

    const date = document.createElement("span");
    date.className = "show-row-date";
    date.innerHTML = parsed.date;

    row.append(venue, date);
    return row;
}

export default function showsLedger() {
    const container = document.querySelector(".shows-page .gh-content");
    if (!container) { return; }

    let currentList = null;

    Array.from(container.children).forEach((el) => {
        if (el.tagName === "H3") {
            const section = document.createElement("div");
            section.className = "show-section";

            const heading = document.createElement("h3");
            heading.innerHTML = el.innerHTML;

            currentList = document.createElement("div");
            currentList.className = "show-list";

            section.append(heading, currentList);
            el.replaceWith(section);
            return;
        }

        if (el.tagName === "H2" || el.tagName === "HR") {
            currentList = null;
            return;
        }

        if (el.tagName === "P" && currentList) {
            const row = buildShowRow(el);
            if (row) {
                currentList.appendChild(row);
                el.remove();
            }
        }
    });
}
